import { React, useEffect, useRef, useState, } from 'react';
import { Row, Col, Button, Space, message, Form, Tag, DatePicker, Select } from 'antd';
import dayjs from 'dayjs';
import { useNavigate, } from 'react-router-dom'
import { default as ProTableOT } from "../../../../utility/ProTable_ot";
// import SystemHolidayModal from './SystemHolidayModal';
import { PlusOutlined } from "@ant-design/icons";
import { useClass } from '../../Class/controller/ClassController';
import { usePunchManagementController } from '../controller/usePunchManagementController';
// import { useSystemHoliday } from '../controller/useSystemHolidayController';


const PunchOverview = () => {
    const navigate = useNavigate();
    const actionRef = useRef()
    const [extra_columns, set_extra_columns] = useState([]);
    const [loading, set_loading] = useState(0);
    const [pageSize, setPageSize] = useState(20)
    const [columns, setColumns] = useState([
        {
            title: '上課日期',
            key: 'only_date',
            dataIndex: 'only_date',
            align: 'center',
            sorter: false,
        },
        {
            title: '班級',
            key: 'class_name',
            dataIndex: 'class_name',
            align: 'center',
            // disabled: true,
            sorter: false,
        },
        {
            title: '班級編號',
            key: 'class_name_serial',
            dataIndex: 'class_name_serial',
            sorter: false,
            // disabled: true,
            align: 'center',
        },
        {
            title: '上課時段',
            key: 'week_time_data',
            dataIndex: 'week_time_data',
            sorter: false,
            disabled: true,
            align: 'center',
            render: (text, record, index) => {
                return <Space direction="vertical">
                    {text.map((value) => {
                        return <Tag color="geekblue">
                            星期{value.week_name} {value?.time_start}-{value?.time_end}
                        </Tag>
                    })}
                </Space>
            }
        },
        {
            title: '出勤總覽',
            // title: '打卡確認（學生打卡/確認/全部）',
            key: 'count_user_punch_record',
            dataIndex: 'count_user_punch_record',
            sorter: false,
            disabled: true,
            align: 'center',
            render: (text, record, index) => {
                return (

                    <Space
                        size={"small"}
                    >
                        <Space
                            size={"small"}
                            direction='vertical'
                            align='center'
                        >
                            <>
                                {record?.count || 0}
                            </>
                            <Tag color='gold'>
                                應到
                            </Tag>
                        </Space>
                        <Space
                            size={"small"}
                            direction='vertical'
                            align='center'
                        >
                            <>
                                {record?.count_user_punch_record_attend || 0}
                            </>
                            <Tag color='green'>
                                出席
                            </Tag>
                        </Space>
                        <>/</>
                        <Space
                            size={"small"}
                            direction='vertical'>
                            <>
                                {record?.count_user_punch_record_leave || 0}

                            </>
                            <>
                                <Tag color='orange'>
                                    請假
                                </Tag>
                            </>
                        </Space>
                        <>/</>

                        <Space
                            size={"small"}
                            direction='vertical'>
                            <>
                                {record?.count_user_punch_record_other || 0}
                            </>
                            <>
                                <Tag color='blue'>
                                    其他
                                </Tag>
                            </>
                        </Space>
                        <Space
                            size={"small"}
                            direction='vertical'>
                            <>
                                {record?.count_user_punch_record_not || 0}

                            </>
                            <>
                                <Tag >
                                    未點名
                                </Tag>
                            </>
                        </Space>

                    </Space>

                )
            }
        },
        {
            title: '詳情',
            key: 'option',
            dataIndex: 'option',
            align: 'center',
            sorter: false,
            disabled: true,
            render: (text, record, index) => {
                return <>
                    {/* <Button
                        onClick={() => {
                            deleteSystemHolidaySettingData([
                                {
                                    holiday_setting_id: record?.holiday_setting_id
                                }
                            ])
                        }}
                    >
                        刪除
                    </Button> */}
                    <Button
                        type="primary"
                        onClick={() => {
                            navigate(`/cramSchool/admin/ClassStudentPunchDetail/${record?.grade_class_id}/${record?.only_date}`)
                        }}
                    >
                        詳細
                    </Button>
                </>
            }
        }
    ]);

    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [searchData, setSearchData] = useState({
        grade_class_id: null,
        only_date: [dayjs(),dayjs()]
    })
    const reload = () => {
        actionRef.current.reloadAndRest();
    }

    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }

    const {
        classOption,
        getClassOption,
    } = useClass({
        onBefore: () => { },
        onFinish: () => { }
    })
    const {
        getPunchManagementData
    } = usePunchManagementController({
        onBefore: () => { },
        onFinish: () => { }
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useTableColumnsCheck(columns)

    useEffect(() => {
        checkAll()
        getClassOption()
    }, []);

    useEffect(() => {
        actionRef.current.reload()
    }, [searchData])
    
    return (
        <Row gutter={[8, 8]}>

            <Col span={24}>
                <Row gutter={[8, 16]}>
                    <Col span={24}>
                        <Row gutter={[8, 16]} justify={"end"}>
                            <Col>
                                <Space
                                >
                                    <div>
                                        班級：
                                    </div>
                                    <Select
                                        allowClear={true}
                                        placeholder={"選擇班級"}
                                        popupMatchSelectWidth={false}
                                        options={classOption.map((val)=>{
                                            let grade_class_data = val?.grade_class_data || []
                                            let grade_class_data_first = grade_class_data.find((ele)=>true)
                                            let grade_class_id = grade_class_data_first?.grade_class_id
                                            return {
                                                label:`${val?.name} ${val?.name_serial}`,
                                                value:`${grade_class_id}`
                                            }
                                        })}                                        value={searchData?.grade_class_id}
                                        onChange={(val) => {
                                            setSearchData((pre) => {
                                                return {
                                                    ...pre,
                                                    grade_class_id: val
                                                }
                                            })
                                        }}
                                    >
                                    </Select>
                                </Space>
                            </Col>
                            <Col>
                                <Space
                                >
                                    <div>
                                        上課日期：
                                    </div>
                                    <DatePicker.RangePicker
                                        format={"YYYY-MM-DD"}
                                        value={searchData?.only_date}
                                        onChange={(val) => {
                                            setSearchData((pre) => {
                                                return {
                                                    ...pre,
                                                    only_date: val ?? []
                                                }
                                            })
                                        }}
                                    />

                                </Space>

                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <ProTableOT
                            actionRef={actionRef}
                            columns={columns}
                            check={check}
                            setCheck={setCheck}
                            rowKey={'holiday_setting_id'}
                            selections={{
                                // onChange: (index_, data_) => set_data(data_)
                            }}
                            toolBarRender={() => [
                            ]}
                            extra_columns={extra_columns}
                            set_extra_columns={set_extra_columns}
                            manage_columns={false}
                            request={async (params = {}, sort, filter) => {
                                let only_date_start = null
                                let only_date_end = null
                                let only_date = searchData?.only_date || []

                                if (only_date.length > 0) {
                                    only_date_start = dayjs(only_date[0]).format("YYYY-MM-DD")
                                    only_date_end = dayjs(only_date[1]).format("YYYY-MM-DD")
                                }

                                let newParams = {
                                    grade_class_id: searchData?.grade_class_id,
                                    date_start: only_date_start,
                                    date_end: only_date_end
                                };
                                let order = setOrders(sort)
                                newParams = {
                                    ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                    ...newParams,
                                    order,
                                    size: params.pageSize,
                                    cur_page: params.current,
                                    custom_filter_value: params.keyword ?? "",
                                    custom_filter_key: custom_filter_key
                                };
                                newParams = setParamsFilter({
                                    ...newParams,
                                });
                                setPageSize(params?.pageSize ?? 20)

                                return getPunchManagementData(newParams)
                            }}
                            pageSize={pageSize}
                            scroll={{
                                x: "max-content"
                            }}
                            rowSelection={false}
                        />
                    </Col>
                </Row>
            </Col>

        </Row>
    )
}
const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([])
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    }
    const setOrders = (sorter) => {
        if (sorter) {
            let newOrders = Object.keys(sorter).map((key, index) => {
                if (sorter[key] === "descend") {
                    return JSON.stringify({
                        column: key,
                        type: 'DESC'
                    })
                }
                else {
                    return JSON.stringify({
                        column: key,
                        type: 'ASC'
                    })
                }

            })
            return newOrders
        }
        else {
            return []
        }
    }
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders
    }
}
const setParamsFilter = (obj) => {
    //拿掉值為空或是null 的東西
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}
export default PunchOverview;